import { useI18n } from "vue-i18n"
import { computed, ComputedRef } from "vue"

export function useHelpdeskLink(links: Record<string, string>): ComputedRef {
  const i18n = useI18n()
  return computed(() => links[i18n.locale.value] ?? links.en)
}
